import React, { useEffect, useState } from "react";
import "./Homepage.scss";
import { useNavigate } from "react-router-dom";
import { useIdleTimer } from "../../context/idleTimoutContext";
import Button from "../../components/Buttons";
import { getDocument, screensaverApi } from "../../proxy";
import { usePages } from "../../context/pagesContext";
import Carousel from "../../components/Carousel";

function Homepage() {
  const navigate = useNavigate();
  const idleTimer = useIdleTimer();
  const { pages, homepage } = usePages()!;
  const showHomepageScreensaver = idleTimer?.showHomepageScreensaver;
  const [slides, setSlides] = useState<any>([]);
  const [screensaverVideoSrc, setScreensaverVideoSrc] = useState<string>("");

  useEffect(() => {
    getScreensaverSlides();
  }, []);
  const getScreensaverSlides = async () => {
    let _slides = (await screensaverApi.get()) as any;
    _slides = _slides?.media?.map((slide: any) => {
      return {
        duration: 10,
        ...slide,
      };
    });
    setSlides(_slides);
  };

  return (
    <div className="homePage">
      <div className="head">
        <div className="text">
          <p>
            {homepage?.headerTitle
              ? homepage.headerTitle
              : "Bronze Cattle Drive Sculpture"}
          </p>
          <p className="color">
            {homepage?.headerSubTitle ? homepage.headerSubTitle : "July 2022"}
          </p>
        </div>
        <img src="/images/logo.svg" />
      </div>

      <div className="content">
        <div className="left">
          <h1>
            {homepage?.title
              ? homepage.title
              : "Cattle Ranching Yesterday, Today and Tomorrow"}
          </h1>
          <p>
            {homepage?.description
              ? homepage.description
              : "Okeechobee Main Street’s Arts & Culture Alliance Project celebrating history & lifestyle through the arts"}
          </p>

          <div className="imgText">
            <img src="/images/infoimg.png" />
            <p>
              Sculpture sponsored by Community & Corporate Donations in
              partnership with Okeechobee County Tourist Development
            </p>
          </div>

          <Button
            click={() => navigate(`pages/${pages[0].slug}`)}
            text="Touch Here to Begin"
          ></Button>
        </div>
        <div className="right images">
          <div
            className={`col1 ${homepage?.gallery.length === 1 ? "full" : ""}`}
          >
            {homepage?.gallery.length ? (
              <>
                {homepage?.gallery.map((item: any, index: number) => {
                  return index <= 2 && <img src={item.src} key={index} />;
                })}
              </>
            ) : (
              <>
                <img src="/images/img1.png" />
                <img src="/images/img2.png" />
                <img src="/images/img3.png" />
              </>
            )}
          </div>
          <div
            className={`col2 ${homepage?.gallery.length === 1 ? "none" : ""}`}
          >
            {homepage?.gallery.length ? (
              <>
                {homepage?.gallery.map((item: any, index: number) => {
                  return index >= 3 && <img src={item.src} key={index} />;
                })}
              </>
            ) : (
              <>
                <img src="/images/img4.png" />
                <img src="/images/img5.png" />
              </>
            )}
          </div>
        </div>
      </div>

      {slides?.length && (
        <div
          className={`screensaver fadeInAndOut ${
            showHomepageScreensaver ? "fadeIn" : "fadeOut"
          }`}
        >
          <Carousel slides={slides} />
          {/* <div className="content">
          <img src="/images/logo.svg" />
        </div> */}

          <Button text="Touch Here to Begin"></Button>
        </div>
      )}
    </div>
  );
}

export default Homepage;
